import { render } from "./personnel-follow.vue?vue&type=template&id=ffab6f36&ts=true"
import script from "./personnel-follow.vue?vue&type=script&lang=ts"
export * from "./personnel-follow.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/workshop/teambition-frontend/node_modules/.pnpm/vue-loader@16.8.3_6zog4g7lmcedlfqueoidvwcx7q/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__